<template>
    <div class="c-modelInput">
        <input type="text" v-model="value" v-on:change="emitValue()" class="c-modelInput__input" :placeholder="placeholder">
    </div>
</template>
<script>
export default {
    data(){
        return {
            value:''
        }
    },
    props:['placeholder'],
    methods:{
        emitValue(){
            this.$emit('getModel',this.value);
            this.$emit('isValid',this.value.length > 0);
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-modelInput{
        &__input{
            width: 100%;
            max-width: 812px;
            font-family: 'Montserrat';
            padding: .75rem 1rem;
            border: 1px solid $gray;
            font-size: 1rem;
            border-radius: .25rem;
            font-size: .9rem;
            color: $black;
            outline: 0;
            &:focus,&:focus-visible{
                border: 1px solid $darkLazuri;
            }   
            &::placeholder{
                color: $black;
            }
        }
    }
</style>